















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseGroupCarac from '@/components/groupCarac/edit/EditBaseGroupCarac.vue'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'
import * as rules from '@/utils/validationRules'

@Component({
  name: 'EditConfig',    
  components:{EditBaseGroupCarac},  
  props: {   
  }      
})
export default class EditConfig extends Vue {
  
  private groupCarac = getDefaultAloGroupCarac()
    
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloGroupCarac) {            
    this.groupCarac =  (this.$refs.baseEdit as EditBaseGroupCarac).edit(item)  
  }  
  
}
